import React from 'react';
import { shape } from 'prop-types';
import classnames from 'classnames';
import { isNumber } from 'underscore';

import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { TooltipWrapper } from '@bingads-webui-campaign-react/smart-component-primitive';

import { professionalServicePropTypes } from '../consts/prop-types';

const UnStyledSmartProfessionalServiceEditorItemView = ({
  classes,
  item,
  i18n,
}) => {
  const { name, price, description } = item;
  return (
    <div className={classnames(classes.container, 'professional-service-editor-item-view')}>
      <div className={classes.contentContainer}>
        <span className={classnames(classes.serviceName, 'service-name')}>
          {name}
        </span>
        {
          isNumber(price) &&
          <span className={classnames(classes.servicePrice, 'service-price')}>
            {`${i18n.getString(_TL_('Price'))}: $${price}`}
          </span>
        }
        {
          description &&
          <TooltipWrapper content={description} lineClamp={4}>
            <span className={classnames(classes.serviceDescription, 'service-description')}>
              {description}
            </span>
          </TooltipWrapper>
        }
      </div>
    </div>
  );
};

UnStyledSmartProfessionalServiceEditorItemView.propTypes = {
  classes: shape({}).isRequired,
  item: professionalServicePropTypes.isRequired,
  i18n: shape({}).isRequired,
};

export const SmartProfessionalServiceEditorItemView = withDefaultStyles(
  UnStyledSmartProfessionalServiceEditorItemView,
  () => ({
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      position: 'relative',
      width: '100%',
    },
    contentContainer: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-evenly',
      fontSize: '14px',
    },
    serviceName: {
      fontWeight: 'bold',
      fontSize: '16px',
      marginBottom: '3px',
    },
    servicePrice: {
      color: '#797775',
      fontWeight: 600,
      marginBottom: '3px',
    },
    serviceDescription: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 2,
    },
  })
);
